import * as THREE from "three";

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

let h = window.innerHeight;
let perspective = 65;
if (document.getElementById("heightScene")) {
  h = document.getElementById("heightScene").value;
  perspective = 10;
}

if (isMobile) {
  perspective = 80;
}

let camera = new THREE.PerspectiveCamera(
  perspective,
  window.innerWidth / h,
  0.1,
  10000
);



export { camera };